import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import React from "react";
import { Link } from "react-router-dom";
import { useTaskpaneTelemetry } from "../telemetry/useTaskpaneTelemetry";

const ActionableCard: React.FC<{
  title: string;
  icon?: React.ReactNode;
  link?: string;
  handleClick?: () => void;
  disabled?: boolean;
  fullHeight?: boolean;
  telemetryDashboardEntry?: string;
  telemetryReceivablesHubAction?: "suggested" | "search";
}> = ({
  title,
  icon,
  handleClick,
  link,
  disabled,
  fullHeight = true,
  telemetryDashboardEntry,
  telemetryReceivablesHubAction,
}) => {
  const { trackNavigationDashboardEntryClicked, trackNavigationReceivablesHubAction } = useTaskpaneTelemetry();

  const emitNavigationTelemetry = () => {
    if (telemetryDashboardEntry) {
      trackNavigationDashboardEntryClicked({ entry_id: telemetryDashboardEntry });
    }
    if (telemetryReceivablesHubAction) {
      trackNavigationReceivablesHubAction({ hub_action: telemetryReceivablesHubAction });
    }
  };

  return (
    <Card
      style={{
        opacity: disabled ? 0.6 : 1,
        height: fullHeight ? "100%" : "auto",
        display: "flex",
        wordWrap: "break-word",
      }}
      elevation={0}
    >
      <CardActionArea onClick={handleClick} disabled={disabled}>
        {link ? (
          <Link
            to={link}
            onClick={() => emitNavigationTelemetry()}
            style={{ textDecoration: "none", color: "inherit", height: "100%" }}
          >
            <CardContent style={{ textAlign: "center", paddingBottom: "16px" }}>
              {icon}
              <Typography>{title}</Typography>
            </CardContent>
          </Link>
        ) : (
          <span style={{ textDecoration: "none", color: "inherit", height: "100%", display: "block" }}>
            <CardContent style={{ textAlign: "center", paddingBottom: "16px" }}>
              {icon}
              <Typography>{title}</Typography>
            </CardContent>
          </span>
        )}
      </CardActionArea>
    </Card>
  );
};

export default ActionableCard;
